import React from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { UserPlus, HardHat, Calculator, FileText, Package, Truck, Wrench, CheckSquare, CalendarClock } from "lucide-react";

const ACTIONS = [
  { label: "Nouveau client", icon: UserPlus, to: "/crm?new=client", tid: "qn-client" },
  { label: "Nouveau prospect", icon: UserPlus, to: "/crm?new=prospect", tid: "qn-prospect" },
  { label: "Nouveau chantier", icon: HardHat, to: "/chantiers?new=1", tid: "qn-chantier" },
  { label: "Nouveau calcul", icon: Calculator, to: "/calculs", tid: "qn-calcul" },
  { label: "Nouveau devis", icon: FileText, to: "/devis?new=1", tid: "qn-devis" },
  { label: "Nouveau fournisseur", icon: Package, to: "/crm?new=fournisseur", tid: "qn-fournisseur" },
  { label: "Nouveau sous-traitant", icon: Truck, to: "/crm?new=sous-traitant", tid: "qn-sous-traitant" },
  { label: "Nouveau matériel", icon: Wrench, to: "/materiel?new=1", tid: "qn-materiel" },
  { label: "Nouvelle tâche", icon: CheckSquare, to: "/taches?new=1", tid: "qn-tache" },
  { label: "Nouvelle visite", icon: CalendarClock, to: "/taches?new=visite", tid: "qn-visite" },
];

export default function QuickNew({ open, onClose }) {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md" data-testid="quick-new-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl uppercase">+ Nouveau</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {ACTIONS.map((a) => (
            <button key={a.label} data-testid={a.tid}
              onClick={() => { onClose(); navigate(a.to); }}
              className="flex items-center gap-3 p-4 rounded-xl border-2 border-border bg-card hover:border-amber-500 hover:shadow-md transition-all text-left touch-target">
              <a.icon className="h-6 w-6 text-amber-600 shrink-0" />
              <span className="font-semibold text-sm">{a.label}</span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
